import { Component, input } from '@angular/core';
import { StatusSidebar } from '@app/shared/components/status-sidebar/status-sidebar';
import { IssueService } from '../../projects.service';

@Component({
  selector: 'app-issue-status',
  standalone: true,
  imports: [StatusSidebar],
  templateUrl: './issue-status.html',
  styleUrl: './issue-status.scss'
})
export class IssueStatus {
  issueId = input<string | null>(null);
  refreshTrigger = input<number>(0);
  
  // Configuration for issue status
  issueConfig = {
    type: 'issue' as const,
    title: 'Manage Issue',
    statusLabel: 'Status',
    assignLabel: 'Assigned To',
    plannedHoursLabel: 'Planned Hrs',
    dueDateLabel: 'Due on',
    refNumberLabel: 'Ref No.',
    showPlannedHours: true,
    showDueDate: true,
    showRefNumber: true,
    showApprovals: true,
    showTimeSummary: true,
    customFields: []
  };

  constructor(public issueService: IssueService) {}
}
